
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MdsIcon, MdsIconsModule } from '@mds/icons';
import { LoaderModule, SearchBarComponent, TemplateCardComponent } from '@mds/ui';
import { ToastrService } from '@services/toaster.service';
import { ComposerApiService } from '@services/composer-api.service';
import { ContainerReloadService } from '@services/container-reload.service';
import { InlineFormSchemaDialogComponent } from '../inline-form-schema-dialog/inline-form-schema-dialog.component';

@Component({
  selector: 'app-attribute-search-dialog',
  templateUrl: './attribute-search-dialog.component.html',
  styleUrls: ['./attribute-search-dialog.component.scss'],
  standalone: true,
  imports: [LoaderModule, MatDialogModule, MdsIconsModule, SearchBarComponent, TemplateCardComponent]
})
export class AttributeSearchDialogComponent implements OnInit {
  icon = MdsIcon;
  placeholder = 'Search attributes';
  attributeList: any = [];
  isLoading = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private containerReloadService: ContainerReloadService,
    private composerApiService: ComposerApiService,
    public dialog: MatDialog,
    public dialogClose: MatDialogRef<AttributeSearchDialogComponent>,
    public dialogRefInlineForm: MatDialogRef<InlineFormSchemaDialogComponent>,
    private toastrService: ToastrService
  ) {}

  ngOnInit(): void {
    this.fetchData();
  }

  fetchData(value = ''): void {
    this.composerApiService.attributeSearch(value, '').subscribe((res: any) => {
      this.attributeList = res;
    });
  }

  closeModal(): void {
    this.dialogClose.close();
  }

  getAttributeData(attr): void {
    this.isLoading = true;

    this.composerApiService.getAttributeSchema(attr.rid).subscribe((res: any) => {
      this.isLoading = false;
      const schema = {
        formSchema: res.formSchema,
        lines: res.lines,
        header: res.name,
        confirmText: 'Add'
      };
      this.dialogRefInlineForm = this.dialog.open(InlineFormSchemaDialogComponent, {
        data: schema,
        width: '38vw'
      });
      const instance = this.dialogRefInlineForm.componentInstance;
      instance.submitDataEmitter.subscribe((data) => {
        if (data && data.value.Inputs) {
          this.submitPayload(data, attr);
        }
      });
    });
  }

  submitPayload(data, attr): void {
    const tempObj = data.value.Inputs;
    tempObj.in = attr.rid.replace('#', '');
    const processrid = this.data.rid.replace('#', '');

    this.composerApiService.submitEditedMetadata(processrid, tempObj).subscribe({
      next: () => {
        this.containerReloadService.reloadContainerData.next(true);
        this.toastrService.showMessage('Attribute successfully added.', 3000);
        this.closeModal();
      },
      error: () => {
        this.toastrService.showMessage('Unable to add attribute!', 3000);
      }
    });

    this.dialogRefInlineForm.close(data);
  }
}
